module["exports"] = [
  "#{street_suffix} #{streets}"
];
